import { calculateReliability } from '../../utils/elo';
import './ReliabilityBar.css';

/* ─────────────────────────────────────────────────────────────
   RELIABILITY BAR — shows how trustworthy a player's ELO is.

   A higher reliability means the rating is based on many matches
   against a variety of opponents, so it's more accurate.

   Props:
   - matchesPlayed:   integer (total matches)
   - uniqueOpponents: integer (distinct opponents faced)

   Renders a labelled progress bar from 0–100.
   ───────────────────────────────────────────────────────────── */
function ReliabilityBar({ matchesPlayed = 0, uniqueOpponents = 0 }) {
  const score = calculateReliability(matchesPlayed, uniqueOpponents);

  // Color shifts from muted → accent as score grows
  const colorClass =
    score >= 80 ? 'rb-fill-high' :
    score >= 40 ? 'rb-fill-mid'  :
                  'rb-fill-low';

  return (
    <div className="rb-wrap">
      <div className="rb-label-row">
        <span className="rb-label">Reliability</span>
        <span className="rb-score">{score}%</span>
      </div>
      <div className="rb-track">
        <div
          className={`rb-fill ${colorClass}`}
          style={{ width: `${score}%` }}
        />
      </div>
    </div>
  );
}

export default ReliabilityBar;
